export const FORM_COPY = {
  // Input
  INPUT_CHARACTERS_REMAINING: '{numChar} characters remaining',
  INPUT_MAX_CHARACTER_VAR: 'Character limit reached',

  MODAL_WARNING_DATA_LOSS:
    'You will lose all changes upon navigating to another step. Are you sure you want to discard any changes made to this step?',
  UPLOAD_AD: 'I agree, upload now',
  PUBLISH_ADS: 'Publish Ads',
};
